import { get, post, put } from "./api_helper"

export const getProductAPI = params => get("admin/master/product/page", params)

export const getProductListAPI = params =>
  get("admin/master/product/list", params)

export const getProductByIdAPI = id => get(`admin/master/product/${id}`)

export const postProductAPI = data => post("admin/master/product", data)

export const putProductAPI = (data, id) =>
  put(`admin/master/product/${id}`, data)

export const getProductTgType = (id, tg, type) =>
  get(`admin/master/product/${id}/tg/${tg}/type/${type}`)
